export const pluralSuffix = (count: number): string => {
  return count === 1 ? '' : 's';
};

const COMBINING_MARKS = /[\u0300-\u036f]/g;

/** Lower-cased with diacritics stripped, so "Politicas" finds "Políticas". Normalise both sides. */
export const normalizeForSearch = (value: string): string =>
  value.normalize('NFD').replace(COMBINING_MARKS, '').toLowerCase();
